export const SET_SUMMARY_MESSAGE = 'SET_SUMMARY_MESSAGE'
export const TOGGLE_SUMMARY_MESSAGE = 'TOGGLE_SUMMARY_MESSAGE'
export const SET_VIEW_TITLE = 'SET_VIEW_TITLE'
export const SET_CURRENT_KINO_ID = 'SET_CURRENT_KINO_ID'
export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT'
export const SET_ADMIN_NOTIFICATION_COUNT = 'SET_ADMIN_NOTIFICATION_COUNT'
export const SET_SYSTEM_NOTIFICATION_COUNT = 'SET_SYSTEM_NOTIFICATION_COUNT'
export const SET_CAR_NOTIFICATION_COUNT = 'SET_CAR_NOTIFICATION_COUNT'
export const SET_LICENCE_NOTIFICATION_COUNT = 'SET_LICENCE_NOTIFICATION_COUNT'
